/**
 * Handles making the AJAX call to load resort content.
 * Also stores state to know which resorts to load next.
 */

( function( $, window, document, undefined ) {

	$(document).ready(function(){
		// Load more posts button.
		$( '.js-more-posts-button' ).click( function() {
			event.preventDefault();
			ajax_next_posts();
		});

	});

	// AjaxLock is just a flag to prevent double clicks and spamming.
	var ajaxLock = false;

	if ( ajaxLock ) {
		return;
	}

	function ajax_next_posts() {

		ajaxLock = true;

		// How many posts there's total.
		var totalPosts = parseInt( $( '.js-total-posts-count' ).text() );

		// How many have been loaded.
		var postOffset = $( '.single-post' ).length;

		// How many do you want to load in single patch.
		var postsPerPage = 3;

		// Hide button if all posts are loaded.
		if( totalPosts < postOffset + ( 1 * postsPerPage ) ) {
			$( '.js-more-posts-button' ).fadeOut();
		}

		// Get admin ajax url.
		var ajaxURL = sirus_config.admin_ajax;

		// Parameters you want to pass to query.
		var ajaxData = '&post_offset=' + postOffset + '&action=ajax_next_posts';

		// Ajax call itself.
		$.ajax({

			type: 'get',
			url:  ajaxURL,
			data: ajaxData,
			dataType: 'json',

			// Ajax call is successful.
			success: function ( response ) {

				// Add new posts.
				$( '.js-posts-container' ).append( response[0] );

				// Update the count of total posts.
				$( '.js-total-posts-count' ).text( response[1] );

				ajaxLock = false;

			},

			// Ajax call is not successful, still remove lock in order to try again.
			error: function ( response ) {
				ajaxLock = false;
			}

		});
	}

} )( jQuery, window, document );
